import type { ExcalidrawElement } from "@excalidraw/element/types";

export const generateFlutterCode = (elements: readonly ExcalidrawElement[]): string => {
  if (elements.length === 0) return "";

  const flutterSnippets = elements.map((el) => {
    // Helper to convert hex to Flutter Color
    const toFlutterColor = (hex: string) => {
      if (hex === "transparent") return "Colors.transparent";
      const cleanHex = hex.replace("#", "");
      if (cleanHex.length === 6) {
        return `Color(0xFF${cleanHex.toUpperCase()})`;
      }
      return `Color(0xFF000000)`;
    };

    switch (el.type) {
      case "rectangle":
      case "ellipse":
      case "diamond":
        const isCircle = el.type === "ellipse";
        let shapeCode = "";
        
        if (isCircle) {
          shapeCode = `shape: BoxShape.circle,`;
        } else if (el.type === "rectangle" && el.roundness !== null) {
          shapeCode = `borderRadius: BorderRadius.circular(8.0),`; // approximate
        }

        const borderCode = el.strokeColor !== "transparent" 
          ? `border: Border.all(color: ${toFlutterColor(el.strokeColor)}, width: ${el.strokeWidth}),` 
          : "";

        return `Container(
  width: ${Math.round(el.width)},
  height: ${Math.round(el.height)},
  decoration: BoxDecoration(
    color: ${toFlutterColor(el.backgroundColor)},
    ${shapeCode}
    ${borderCode}
  ),
)`;
        
      case "text":
        // @ts-ignore - text exists on text elements
        const text = el.text || "";
        return `Text(
  '${text.replace(/'/g, "\\'")}',
  style: TextStyle(
    color: ${toFlutterColor(el.strokeColor)},
    fontSize: ${el.fontSize},
  ),
)`;

      case "line":
      case "arrow":
        return `// Custom ${el.type} - Requires CustomPaint in Flutter\n// Color: ${toFlutterColor(el.strokeColor)}, Stroke: ${el.strokeWidth}`;

      case "image":
        return `Image.network(
  'https://via.placeholder.com/${Math.round(el.width)}x${Math.round(el.height)}',
  width: ${Math.round(el.width)},
  height: ${Math.round(el.height)},
)`;

      default:
        return `// Unsupported type: ${el.type}`;
    }
  });

  if (flutterSnippets.length === 1) {
    return flutterSnippets[0];
  }

  return `Stack(
  children: [
    ${flutterSnippets.map((code) => code.split('\\n').map(line => `    ${line}`).join('\\n').trimStart()).join(',\\n    ')}
  ],
)`;
};
